import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=99c5852c&scoped=true"
import script from "./ReturnDialog.vue?vue&type=script&lang=js"
export * from "./ReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./ReturnDialog.vue?vue&type=style&index=0&id=99c5852c&prod&lang=scss&scoped=true"
import style1 from "./ReturnDialog.vue?vue&type=style&index=1&id=99c5852c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c5852c",
  null
  
)

export default component.exports